import trae from 'trae'
import configService from '@/services/config'

const widgetService = trae.create({
  baseUrl: configService.baseUrl
})

widgetService.getStatus = function (url) {
  if (url) {
    return trae.get(url)
      .then(function (res) {
        if (typeof (res.data) !== 'object') return JSON.parse(res.data)
        else return res.data
      })
  } else {
    return widgetService.get(configService.uris.status)
      .then(function (res) {
        if (typeof (res.data) !== 'object') return JSON.parse(res.data)
        else return res.data
      })
  }
}

widgetService.getConditions = function (url) {
  if (url) {
    return trae.get(url)
      .then(function (res) {
        if (typeof (res.data) !== 'object') return JSON.parse(res.data)
        else return res.data
      })
  } else {
    return widgetService.get(configService.uris.conditions)
      .then(function (res) {
        if (typeof (res.data) !== 'object') return JSON.parse(res.data)
        else return res.data
      })
  }
}

export default widgetService



// WEBPACK FOOTER //
// ./src/services/widget-service.js